import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm, submit, getFormValues } from 'redux-form'
import ModalHandler from 'components/shared/modal/modal-handler'
import QuestionModal from 'components/shared/modals/question'
import keys from 'lodash/keys'
import Fields from './fields'
import validate, { requiredFields } from './validator'

const Form = ({ form, spaceOptions = [], acceptSubmit, submit }) => {
  return (<>
    <Fields form={form} spaceOptions={spaceOptions} />
    <div className="footer flex flex-col justify-center">
      <ModalHandler disabled={!acceptSubmit} title="SAVE AND SEND PROPOSAL" className={`${acceptSubmit ? 'bg-primary-orange text-white cursor-pointer' : 'bg-ct-gray text-gray-500 cursor-not-allowed'}
       text-center py-3 px-4 whitespace-no-wrap rounded mx-auto`}>
        {({ toggle }) => (
          <QuestionModal
            confirmTitle={'Confirm'}
            cancelTitle={'Cancel'}
            onClose={toggle}
            onClickYes={() => {
              submit(form)
              toggle()
            }}>
            <div className="p-5">
              <p className="text-lg font-semibold">Send a Proposal Confirmation</p>
              <p className="my-3 font-thin">
                Sending this form will generate a <b>payment link</b> for the client. allowing them to pay
                for the agreed amount stated in the proposal.</p>
              <p className="font-thin">{`Click on 'Confirm' below to confirm this action.`}</p>
            </div>
          </QuestionModal>
        )}
      </ModalHandler>
      <p className="text-sm text-primary-lightgray text-center mt-3">
        Note: Send this Proposal will also send a payment link to the client
      </p>
    </div>
  </>)
}

Form.propTypes = {
  form: PropTypes.string.isRequired,
  submit: PropTypes.func,
  spaceOptions: PropTypes.array,
  acceptSubmit: PropTypes.bool
}

const mapStateToProps = ({ ...state }, { form }) => {
  let acceptSubmit = true
  const fields = keys(requiredFields) || []
  const formValues = getFormValues(form)(state) || {}
  for (let i = 0; i < fields.length; i++) {
    if (!formValues[fields[i]]) {
      acceptSubmit = false
      break
    }
  }
  return {
    acceptSubmit
  }
}

const mapDispatchToProps = {
  submit
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ validate })(Form))
